module.exports = __webpack_public_path__ + "img/PRNT_02_mono_AE_00001.0b2ad092.png";